module.exports = __webpack_public_path__ + "static/media/profile-banner.6a49e37c.png";